import React from "react";
import { Link } from "react-router-dom";
import { IconNewTabLink } from "./Icons";

export default function TabedLink({ url, text, id }) {
  return (
    <>
      <Link data-testid={id} to={url} className="lnk" title="Opens in same tab">
        {text}
      </Link>
      <a data-testid={`${id}-tab`} href={url} target="_blank" rel="noopener noreferrer" className="lnk">
        <IconNewTabLink />
      </a>
    </>
  );
}

export function NewTabLink({url, id, text}){
  return (
    <a data-testid={`${id}-tab`} href={url} target="_blank" rel="noopener noreferrer" className="lnk">
      {text}
     <IconNewTabLink />
    </a>
  )
}